import { Enumify } from "enumify-ts";
class LicenseType extends Enumify() {
    description;
    static CAR = new LicenseType("Car");
    static LIGHT_TRUCK = new LicenseType("Light Truck");
    static HEAVY_RIGID = new LicenseType("Heavy Rigid");
    static HEAVY_COMBINATION = new LicenseType("Heavy Combination");
    static MULTI_COMBINATION = new LicenseType("Multi Combination");
    static _ = LicenseType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return LicenseType.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
}
export default LicenseType;
